/**
 * CMS heading style is `{tag}-{visual}` (e.g. `h2-h1`). The tag sets the HTML element;
 * the visual tier picks display typography (fluid tokens on `.heading-*` utilities).
 */
const defaultHeadingStyle = 'h2-h2'

/** Visual tier (“styling” column) → utility class. */
const headingVisualTierClassMap: Record<string, string> = {
  h1: 'heading-xl',
  h2: 'heading-xl-lg',
  h3: 'heading-lg',
  h4: 'heading-md',
  'text-xl': 'heading-text-xl',
}

export function getHeadingTag(headingStyle?: null | string): 'h1' | 'h2' | 'h3' {
  const key = headingStyle || defaultHeadingStyle
  const prefix = key.split('-')[0]
  if (prefix === 'h1' || prefix === 'h3') return prefix
  return 'h2'
}

export function getHeadingVisualClassName(headingStyle?: null | string): string {
  const raw = headingStyle || defaultHeadingStyle
  const match = raw.match(/^(h[123])-(h[123]|h4|text-xl)$/)
  if (!match) return headingVisualTierClassMap.h2
  return headingVisualTierClassMap[match[2]] ?? headingVisualTierClassMap.h2
}
